/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --background: var(--nve-sys-layer-container-background);
  --min-height: var(--nve-ref-size-400);
  --border-radius: var(--nve-ref-border-radius-xs);
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
}

[internal-host] {
  background: var(--background);
  min-height: var(--min-height);
  border-radius: var(--border-radius);
  height: 100%;
  width: 100%;
}

:host([shape='round']) {
  --border-radius: var(--nve-ref-border-radius-full);
}

:host([shape='pill']) {
  --border-radius: var(--nve-ref-border-radius-lg);
}

:host([effect='shimmer']) [internal-host] {
  animation: shimmer calc(var(--nve-ref-animation-duration-400) * 4);
  animation-iteration-count: infinite;
  background: linear-gradient(
    to right,
    var(--background) 5%,
    color-mix(in srgb, var(--background), var(--nve-sys-interaction-state-mix) 5%) 25%,
    var(--background) 35%
  );
  background-size: 1000px 100%;
}

@keyframes shimmer {
  from {
    background-position: -1000px 0;
  }

  to {
    background-position: 1000px 0;
  }
}

:host([effect='pulse']) [internal-host] {
  animation: calc(var(--nve-ref-animation-duration-400) * 2) ease-in-out var(--nve-ref-animation-duration-300) infinite
    normal none running pulse;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }

  50% {
    opacity: var(--nve-ref-opacity-500);
  }

  100% {
    opacity: 1;
  }
}

/* if slotted content is provided hide the skeleton */
:host(:state(slotted)) {
  display: contents;
}

:host(:state(slotted)) [internal-host] {
  display: contents;
  background: none;
  min-height: 0;
  animation: none;
}

:host(:state(slotted)) .animate {
  display: none;
}
